import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.i5t_1 = delegate;
        this.j5t_1 = call;
      }
      *t5b(frame, $completion) {
        yield* this.i5t_1.t5b(frame, $completion);
        return Unit_instance;
      }
      *m4k($completion) {
        yield* this.i5t_1.m4k($completion);
        return Unit_instance;
      }
      p5b(_set____db54di) {
        this.i5t_1.p5b(_set____db54di);
      }
      q5b() {
        return this.i5t_1.q5b();
      }
      r5b() {
        return this.i5t_1.r5b();
      }
      s5b() {
        return this.i5t_1.s5b();
      }
      cw() {
        return this.i5t_1.cw();
      }
      o5b(negotiatedExtensions) {
        this.i5t_1.o5b(negotiatedExtensions);
      }
      n5b() {
        return this.i5t_1.n5b();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.k5t_1 = session;
        this.l5t_1 = call;
      }
      *t5b(frame, $completion) {
        yield* this.k5t_1.t5b(frame, $completion);
        return Unit_instance;
      }
      *m4k($completion) {
        yield* this.k5t_1.m4k($completion);
        return Unit_instance;
      }
      p5b(_set____db54di) {
        this.k5t_1.p5b(_set____db54di);
      }
      q5b() {
        return this.k5t_1.q5b();
      }
      r5b() {
        return this.k5t_1.r5b();
      }
      s5b() {
        return this.k5t_1.s5b();
      }
      cw() {
        return this.k5t_1.cw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
